import React from 'react';

import JFormBaseField from './j_form_base_field';

const JFormTextField = (props) => {
  return <JFormBaseField type="text" {...props} />;
};

export default React.memo(JFormTextField);